import React, { Component } from "react";
import { Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import Iframe from 'react-iframe';
import GLOBALS from '../../utils/Constants';
import UsersService from "../../services/users-service";

class Learning extends Component {


  constructor(props, context) {
      super(props, context);


      this.state = {
        iframeUrl: ""//"https://archontech.litmos.com/login.aspx?loginkey=62e41532-008f-4469-a35c-44bc57fa86e0&titlebar=false",
      };

      this.getLitmosUserData = this.getLitmosUserData.bind(this);
      this.doLitmosLogIn = this.doLitmosLogIn.bind(this);
  }

  componentDidMount() {
    var userId = 'tOjMtb8MtqkNlJ5We1t3LQ2';


    //get Litmos User Data and display iframe
    this.getLitmosUserData();

    //for now hardcode this iframe
    //var userId = 'tOjMtb8MtqkNlJ5We1t3LQ2';
    //this.doLitmosLogIn();
  }
  render() {
    return (<div style={{width:"100%", height:"100vh", paddingRight:"30px",overflow:"auto"}}>
                <Iframe url={this.state.iframeUrl}
                id="myId"
                className="myClassname"
                display="initial"
                position="relative"
                style={{width:"100%", height:"800px", border:"none",margin:"0", padding:"0"}}
                allowFullScreen />
            </div>);
  }

  getLitmosUserData(){

    const storedCredenials = UsersService.sharedInstance.getStoredCredentials();

    const loginResponse = storedCredenials.loginResponse;

    if(loginResponse != null) {
      try{
         const sub_user_id = loginResponse.data[0].recno;
         var params = {
          "license":storedCredenials.license,
          "auth_username":storedCredenials.username,
          "token":storedCredenials.token,
          "sub_user_id":sub_user_id,
          "litmos_license":storedCredenials.license
        };

        UsersService.sharedInstance.getLitmosUserData(params)
        .then((response)=>{
            this.doLitmosLogIn(response.lms_user_id);
        }).catch((error)=>{

        });
      }
      catch(e){
        console.log("error", e);
      }
    }
  }

  doLitmosLogIn(userid) {
    var request = GLOBALS.API_LITMOS_URL + "userid=" + userid;
    try
    {
      fetch(request,
        {
          method: 'GET',
        }
      )
      .then(response => response.text())
      .then(str => (new window.DOMParser()).parseFromString(str, "text/xml"))
      .then(data => {
        var docElt = data.documentElement;
        var loginKeyElt = this.childWithTagName(docElt, "LoginKey");
        if(loginKeyElt) {
          var loginKey = loginKeyElt.textContent;
          this.setState({
            iframeUrl: loginKey + '&titlebar=false',
          });
        }
      })
        .catch((error)=>{
          console.log("error: ", error);
        });

    } catch(err)
    {
      alert('Error during login: ' + err.message);
    }
  }

childWithTagName(parentElement, tagName)
{
  var children = parentElement.children;
  var child;
  if (children.length > 0) {
    for (var ii = 0, count = children.length; ii < count; ii++) {
      child = children.item(ii);
      if (child.tagName == tagName) {
        return child;
      }
    }
  }

  return null;
}

}

export default Learning;
